/**
 * @deprecated remove as soon as SelectBox gets removed
 */
export enum ActionType {
  SetLoading,
  SetResult,
  SetError,
}

type SetLoading = {
  type: ActionType.SetLoading;
};

type SetResult = {
  type: ActionType.SetResult;
  payload: {
    result: any;
  };
};

type SetError = {
  type: ActionType.SetError;
  payload: {
    error: Error;
  };
};

/**
 * @deprecated remove as soon as SelectBox gets removed
 */
export type Action = SetLoading | SetResult | SetError;

/**
 * @deprecated remove as soon as SelectBox gets removed
 */
export function setLoading(): SetLoading {
  return {type: ActionType.SetLoading};
}

/**
 * @deprecated remove as soon as SelectBox gets removed
 */
export function setResult(result: unknown): SetResult {
  return {
    payload: {result},
    type: ActionType.SetResult,
  };
}

/**
 * @deprecated remove as soon as SelectBox gets removed
 */
export function setError(error: Error): SetError {
  return {
    payload: {error},
    type: ActionType.SetError,
  };
}
